import de from '@translations/de/navbar.json';
import en from '@translations/en/navbar.json';
import pl from '@translations/pl/navbar.json';
import sl from '@translations/sl/navbar.json';
import uk from '@translations/uk/navbar.json';
import bg from '@translations/bg/navbar.json';
import cz from '@translations/cz/navbar.json';
import fr from '@translations/fr/navbar.json';
import gr from '@translations/gr/navbar.json';
import it from '@translations/it/navbar.json';
import pr from '@translations/pr/navbar.json';
import ru from '@translations/ru/navbar.json';
import sk from '@translations/sk/navbar.json';
import sp from '@translations/sp/navbar.json';
import tr from '@translations/tr/navbar.json';
import hu from '@translations/hu/navbar.json';
import { ITranslations } from '@/types/common';
import { NavbarTransFields } from './types';

export const navbarTranslations: ITranslations<NavbarTransFields> = {
  name: 'navbar',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
